import React, { useState, useEffect } from 'react';
import { Container, Typography, Box, Paper, Grid } from '@mui/material';
import EditableContent from './EditableContent';
import config from '../config/config';

// Standardinnehåll
const defaultContent = {
  history_1: "Davidsson BVT grundades med en passion för att bevara och förbättra både byggnader och trädgårds miljöer. Vi kombinerar traditionellt hantverk med moderna metoder för att leverera högsta kvalitet i alla våra projekt.",
  history_2: "Med år av erfarenhet inom både byggnadsvård och trädgårdsarbete har vi utvecklat en djup förståelse för hur man bäst tar hand om både byggnader och grönområden på ett hållbart sätt.",
  history_3: "Vyn vi eftersträvar när man färdas genom vårt avlånga gröna land är, biologisk mångfald, frodiga blomstrande trädgårdar med friska och välskötta hus.",
  value_quality: "Vi strävar alltid efter högsta kvalitet i varje projekt, oavsett storlek. Vårt arbete ska hålla i generationer.",
  value_sustainability: "Vi strävar efter att bygga hållbart genom smarta och genomtänkta lösningar. Med fokus på lång livslängd och resurssnålt byggande skapar vi projekt som håller över tid.",
  value_customer_focus: "Vi lyssnar på våra kunders behov och anpassar våra tjänster för att möta deras specifika önskemål."
};

const About = () => {
  const [content, setContent] = useState(defaultContent);

  useEffect(() => {
    const fetchContent = async () => {
      try {
        const response = await fetch(`${config.api.baseUrl}/cms/pages/about`);
        if (!response.ok) {
          throw new Error('Kunde inte hämta innehåll');
        }
        
        const data = await response.json();
        if (data.content) {
          const fetchedContent = JSON.parse(data.content);
          setContent(prevContent => ({
            ...prevContent,
            ...fetchedContent
          }));
        }
      } catch (error) {
        console.error('Error fetching content:', error);
      }
    };

    fetchContent();
  }, []);

  const handleContentUpdate = (key: string, newContent: string) => {
    setContent(prevContent => ({
      ...prevContent,
      [key]: newContent
    }));
  };

  return (
    <Box sx={{ py: 8 }}>
      <Container maxWidth="lg">
        <Typography variant="h3" component="h1" gutterBottom align="center" sx={{ 
          mb: 6,
          mt: { xs: 4, sm: 8 }
        }}>
          Om DavidssonBVT
        </Typography>

        <Grid container spacing={6}>
          <Grid item xs={12} md={6}>
            <Typography variant="h5" gutterBottom>
              Vår Historia
            </Typography>
            <EditableContent
              content={content.history_1}
              pageName="about"
              contentKey="history_1"
              type="text"
              onUpdate={(newContent) => handleContentUpdate('history_1', newContent)}
            />
            <EditableContent
              content={content.history_2}
              pageName="about"
              contentKey="history_2"
              type="text"
              onUpdate={(newContent) => handleContentUpdate('history_2', newContent)}
            />
            <EditableContent
              content={content.history_3}
              pageName="about"
              contentKey="history_3"
              type="text"
              onUpdate={(newContent) => handleContentUpdate('history_3', newContent)}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <Paper
              elevation={3}
              sx={{
                height: '100%',
                minHeight: 300,
                backgroundColor: '#f5f5f5',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                position: 'relative'
              }}
            >
              <EditableContent
                content=""
                pageName="about"
                contentKey="company_image"
                type="image"
                imageUrl="/path/to/company/image.jpg"
              />
            </Paper>
          </Grid>
        </Grid>

        <Box sx={{ mt: 8 }}>
          <Typography variant="h5" gutterBottom align="center">
            Våra Värderingar
          </Typography>
          <Grid container spacing={4}>
            <Grid item xs={12} md={4}>
              <Paper elevation={2} sx={{ p: 3, height: '100%' }}>
                <Typography variant="h6" gutterBottom>
                  Kvalitet
                </Typography>
                <EditableContent
                  content={content.value_quality}
                  pageName="about"
                  contentKey="value_quality"
                  type="text"
                  onUpdate={(newContent) => handleContentUpdate('value_quality', newContent)}
                />
              </Paper>
            </Grid>
            <Grid item xs={12} md={4}>
              <Paper elevation={2} sx={{ p: 3, height: '100%' }}>
                <Typography variant="h6" gutterBottom>
                  Hållbarhet
                </Typography>
                <EditableContent
                  content={content.value_sustainability}
                  pageName="about"
                  contentKey="value_sustainability"
                  type="text"
                  onUpdate={(newContent) => handleContentUpdate('value_sustainability', newContent)}
                />
              </Paper>
            </Grid>
            <Grid item xs={12} md={4}>
              <Paper elevation={2} sx={{ p: 3, height: '100%' }}>
                <Typography variant="h6" gutterBottom>
                  Kundfokus
                </Typography>
                <EditableContent
                  content={content.value_customer_focus}
                  pageName="about"
                  contentKey="value_customer_focus"
                  type="text"
                  onUpdate={(newContent) => handleContentUpdate('value_customer_focus', newContent)}
                />
              </Paper>
            </Grid>
          </Grid>
        </Box>
      </Container>
    </Box>
  );
};

export default About; 